var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ancet" }, [
    _vm.ancet && !_vm.ancetSended
      ? _c("form", { staticClass: "ancet__form ancet-form" }, [
          _c("div", { staticClass: "ancet-form__fieldset fieldset" }, [
            _c("label", { staticClass: "fieldset__label" }, [
              _vm._v("ФИО заявителя"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row gx-1" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.second_name },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.second_name,
                          expression: "ancet.second_name",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "Фамилия", type: "text" },
                      domProps: { value: _vm.ancet.second_name },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.ancet,
                            "second_name",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.second_name
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.second_name.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.first_name },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.first_name,
                          expression: "ancet.first_name",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "Имя", type: "text" },
                      domProps: { value: _vm.ancet.first_name },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.ancet, "first_name", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.first_name
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first_name.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.third_name },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.third_name,
                          expression: "ancet.third_name",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "Отчество", type: "text" },
                      domProps: { value: _vm.ancet.third_name },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.ancet, "third_name", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.third_name
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.third_name.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ancet-form__fieldset fieldset" },
            [
              _c("label", { staticClass: "fieldset__label" }, [
                _vm._v("Состав семьи"),
              ]),
              _vm._v(" "),
              _c("help-label", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [_vm._v("\n          Супруг, дети\n        ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [_c("p", [_vm._v("ФИО мужа/жены и детей")])]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3191814029
                ),
              }),
              _vm._v(" "),
              _c("family-persons", {
                staticClass: "ancet-form__family-persons",
                attrs: { "ancet-id": _vm.ancet.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ancet-form__form-group form-group",
              class: { "form-group--invalid": _vm.errors.inn },
            },
            [
              _c("label", { staticClass: "form-group__label" }, [
                _vm._v("ИНН заявителя"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ancet.inn,
                    expression: "ancet.inn",
                  },
                ],
                staticClass: "form-group__input form-control",
                attrs: { placeholder: "12 цифр", type: "text" },
                domProps: { value: _vm.ancet.inn },
                on: {
                  change: function ($event) {
                    return _vm.saveAncet(false)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.ancet, "inn", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.inn
                ? _c(
                    "p",
                    {
                      staticClass: "form-group__error-message invalid-feedback",
                    },
                    [_vm._v("\n        " + _vm._s(_vm.errors.inn.join(", ")))]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ancet-form__form-group form-group mb-5",
              class: { "form-group--invalid": _vm.errors.register_address },
            },
            [
              _c("label", { staticClass: "form-group__label" }, [
                _vm._v("Прописка заявителя"),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ancet.register_address,
                    expression: "ancet.register_address",
                  },
                ],
                staticClass: "form-group__textarea form-control",
                attrs: { placeholder: "Область, город, улица, дом, квартира" },
                domProps: { value: _vm.ancet.register_address },
                on: {
                  change: function ($event) {
                    return _vm.saveAncet(false)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.ancet, "register_address", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.register_address
                ? _c(
                    "p",
                    {
                      staticClass: "form-group__error-message invalid-feedback",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.errors.register_address.join(", "))
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ancet-form__fieldset fieldset fieldset-contacts" },
            [
              _c("label", { staticClass: "fieldset__label" }, [
                _vm._v("Контакты заявителя"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row gx-1" }, [
                _c("div", { staticClass: "col-sm-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ancet-form__form-group form-group",
                      class: { "form-group--invalid": _vm.errors.phone },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ancet.phone,
                            expression: "ancet.phone",
                          },
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "+7(###)###-##-##",
                            expression: "'+7(###)###-##-##'",
                          },
                        ],
                        staticClass: "form-group__input form-control",
                        attrs: {
                          placeholder: "+7(xxx)xxx-xx-xx",
                          type: "text",
                        },
                        domProps: { value: _vm.ancet.phone },
                        on: {
                          change: function ($event) {
                            return _vm.saveAncet(false)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.ancet, "phone", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.phone
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "form-group__error-message invalid-feedback",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.phone.join(", "))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ancet-form__form-group form-group",
                      class: { "form-group--invalid": _vm.errors.email },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ancet.email,
                            expression: "ancet.email",
                          },
                        ],
                        staticClass: "form-group__input form-control",
                        attrs: { placeholder: "email", type: "text" },
                        domProps: { value: _vm.ancet.email },
                        on: {
                          change: function ($event) {
                            return _vm.saveAncet(false)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.ancet, "email", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.email
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "form-group__error-message invalid-feedback",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.errors.email.join(", "))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ancet-form__form-group form-group mb-5",
              class: { "form-group--invalid": _vm.errors.ancet_type },
            },
            [
              _c("label", { staticClass: "form-group__label" }, [
                _vm._v("Форма собственности"),
              ]),
              _vm._v(" "),
              _c("help-label", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return undefined
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm._v(
                              "Если уже зарегистрировано ИП, укажите дату постановки на учет, систему налогооблажения и вид деятельности."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Если зарегистрированы как самозанятый, укажите дату регистрации."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v('Иначе выбирайте "Не зарегистрирован".'),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3041779453
                ),
              }),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ancet.ancet_type,
                      expression: "ancet.ancet_type",
                    },
                  ],
                  staticClass: "form-group__input form-control",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.ancet,
                          "ancet_type",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function ($event) {
                        return _vm.saveAncet(false)
                      },
                    ],
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Выбрать"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "person" } }, [
                    _vm._v("Не зарегистрирован"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "ip" } }, [_vm._v("ИП")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "sz" } }, [
                    _vm._v("Самозанятость"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.errors.ancet_type
                ? _c(
                    "p",
                    {
                      staticClass: "form-group__error-message invalid-feedback",
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.errors.ancet_type.join(", "))
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.ancet.ancet_type == "ip"
            ? _c("div", { staticClass: "ancet-form__fieldset fieldset" }, [
                _c("label", { staticClass: "fieldset__label" }, [
                  _vm._v("Информация по ИП"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: {
                      "form-group--invalid": _vm.errors.ip_date_register,
                    },
                  },
                  [
                    _c("label", { staticClass: "form-group__label" }, [
                      _vm._v("Дата регистрации ИП"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ipDateRegister,
                          expression: "ipDateRegister",
                        },
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "##.##.####",
                          expression: "'##.##.####'",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "дд.мм.гггг", type: "text" },
                      domProps: { value: _vm.ipDateRegister },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.ipDateRegister = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.ip_date_register
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.ip_date_register.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.ip_tax },
                  },
                  [
                    _c("label", { staticClass: "form-group__label" }, [
                      _vm._v("Налогооблажение"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ancet.ip_tax,
                            expression: "ancet.ip_tax",
                          },
                        ],
                        staticClass: "form-group__input form-control",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.ancet,
                                "ip_tax",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.saveAncet(false)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("Выбрать"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "usn" } }, [
                          _vm._v("УСН"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "patent" } }, [
                          _vm._v("Патент"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: "tradition" } }, [
                          _vm._v("Общее"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errors.ip_tax
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.ip_tax.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.ip_okved },
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "form-group__label" },
                      [
                        _vm._v("\n          ОКВЭД ИП\n          "),
                        _c("help-label", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n              Вид деятельности ИП\n            "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        "Если знаете основной ОКВЭД вашего ИП, укажите код. Если не знаете, напишите словами вид деятельности, который планируется по бизнес-плану."
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3807370131
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.ip_okved,
                          expression: "ancet.ip_okved",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: {
                        placeholder: "Основной вид деятельности",
                        type: "text",
                      },
                      domProps: { value: _vm.ancet.ip_okved },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.ancet, "ip_okved", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.ip_okved
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.ip_okved.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ancet.ancet_type == "sz"
            ? _c("div", { staticClass: "ancet-form__fieldset fieldset" }, [
                _c("label", { staticClass: "fieldset__label" }, [
                  _vm._v("Самозанятость"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: {
                      "form-group--invalid": _vm.errors.sz_date_register,
                    },
                  },
                  [
                    _c("label", { staticClass: "form-group__label" }, [
                      _vm._v("Дата регистрации"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.szDateRegister,
                          expression: "szDateRegister",
                        },
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "##.##.####",
                          expression: "'##.##.####'",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "дд.мм.гггг", type: "text" },
                      domProps: { value: _vm.szDateRegister },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.szDateRegister = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.sz_date_register
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.sz_date_register.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.sz_business },
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "form-group__label" },
                      [
                        _vm._v("\n          Вид деятельности\n          "),
                        _c("help-label", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return undefined
                                },
                                proxy: true,
                              },
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        "Укажите вид деятельности, которым собираетесь заниматься."
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            860018439
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.sz_business,
                          expression: "ancet.sz_business",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: {
                        placeholder: "Основной вид деятельности",
                        type: "text",
                      },
                      domProps: { value: _vm.ancet.sz_business },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.ancet,
                            "sz_business",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.sz_business
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.sz_business.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ancet.ancet_type == "person"
            ? _c("div", { staticClass: "ancet-form__fieldset fieldset" }, [
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.type_business },
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "form-group__label" },
                      [
                        _vm._v("\n          Вид деятельности\n          "),
                        _c("help-label", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return undefined
                                },
                                proxy: true,
                              },
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        "Укажите вид деятельности, которым собираетесь заниматься."
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            860018439
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.type_business,
                          expression: "ancet.type_business",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "По бизнес-плану", type: "text" },
                      domProps: { value: _vm.ancet.type_business },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.ancet,
                            "type_business",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.type_business
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.type_business.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ancet-form__fieldset fieldset" },
            [
              _c("label", { staticClass: "fieldset__label" }, [
                _vm._v("Ваши услуги (прайс)"),
              ]),
              _vm._v(" "),
              _c("help-label", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return undefined
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("p", [
                            _vm._v(
                              "3-4 услуги или товара, которые планируете продавать (прайс-лист)."
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            [
                              _vm._v("Например: "),
                              _c("br"),
                              _vm._v("свадебная фотосъемка - "),
                              _c("nobr", [_vm._v("6000 руб / час")]),
                              _c("br"),
                              _vm._v("маникюр - 2000 руб"),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2178333955
                ),
              }),
              _vm._v(" "),
              _c("services", {
                staticClass: "ancet-form__services",
                attrs: { "ancet-id": _vm.ancet.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ancet-form__form-group form-group mb-4",
              class: { "form-group--invalid": _vm.errors.business_place },
            },
            [
              _c(
                "label",
                { staticClass: "form-group__label" },
                [
                  _vm._v("\n        Место деятельности\n        "),
                  _c("help-label", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return undefined
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("p", [
                                _vm._v(
                                  "Если планируете вести деятельность дома, так и выбирайте."
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Если потребуется аренда помещения или помещение уже арендовано, укажите адрес и стоимость аренды в месяц."
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3646237811
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.ancet.business_place,
                      expression: "ancet.business_place",
                    },
                  ],
                  staticClass: "form-group__input form-control",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.ancet,
                          "business_place",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function ($event) {
                        return _vm.saveAncet(false)
                      },
                    ],
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Выбрать"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "home" } }, [
                    _vm._v("Дома"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "rent" } }, [
                    _vm._v("Аренда помещения"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.errors.business_place
                ? _c(
                    "p",
                    {
                      staticClass: "form-group__error-message invalid-feedback",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.errors.business_place.join(", "))
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.ancet.business_place == "rent"
            ? _c("div", { staticClass: "ancet-form__fieldset fieldset" }, [
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.place_price },
                  },
                  [
                    _c("label", { staticClass: "form-group__label" }, [
                      _vm._v("Стоимость аренды"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.place_price,
                          expression: "ancet.place_price",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "в месяц", type: "text" },
                      domProps: { value: _vm.ancet.place_price },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.ancet,
                            "place_price",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.place_price
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.place_price.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ancet-form__form-group form-group",
                    class: { "form-group--invalid": _vm.errors.place_address },
                  },
                  [
                    _c("label", { staticClass: "form-group__label" }, [
                      _vm._v("Адрес аренды"),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ancet.place_address,
                          expression: "ancet.place_address",
                        },
                      ],
                      staticClass: "form-group__input form-control",
                      attrs: { placeholder: "город, улица, дом" },
                      domProps: { value: _vm.ancet.place_address },
                      on: {
                        change: function ($event) {
                          return _vm.saveAncet(false)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.ancet,
                            "place_address",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.place_address
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "form-group__error-message invalid-feedback",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.errors.place_address.join(", "))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ancet-form__fieldset fieldset" },
            [
              _c("label", { staticClass: "fieldset__label" }, [
                _vm._v("Образование заявителя"),
              ]),
              _vm._v(" "),
              _c("help-label", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return undefined
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [_c("p", [_vm._v("Где и на кого учились")])]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3110925513
                ),
              }),
              _vm._v(" "),
              _c("education", { attrs: { "ancet-id": this.ancet.id } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ancet-form__fieldset fieldset" },
            [
              _c("label", { staticClass: "fieldset__label" }, [
                _vm._v("Опыт работы"),
              ]),
              _vm._v(" "),
              _c("help-label", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return undefined
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("p", [_vm._v("Где работали. По трудовой и нет.")]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3584379172
                ),
              }),
              _vm._v(" "),
              _c("work-experience", { attrs: { "ancet-id": this.ancet.id } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ancet-form__fieldset fieldset" },
            [
              _c("label", { staticClass: "fieldset__label" }, [
                _vm._v("Что планируете закупать?"),
              ]),
              _vm._v(" "),
              _c("help-label", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n          Что планируете закупать на средства соцконтракта\n        "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("p", [_vm._v("На 350 000 руб.")]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [_vm._v("МАКСИМАЛЬНЫЕ суммы")]),
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [_vm._v("52 500 – аренда;")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("52 500 – расходники;")]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "17 500 – вывеска (реклама) – больше НЕ ДАДУТ!"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v("15 000 – ремонт (больше НЕ ДАДУТ)"),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", [
                                _vm._v(
                                  "212 500 – оборудование и мебель (необходимо перечислить)"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v("(«стол – 15000руб/1шт»)")]),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Либо все 350 000 – оборудование (с ценами и кол-вом). Например: аппарат для эпиляции – 350 000."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Если Вы этого не предоставляете, то мы пишем сами, и исправляем по ВАШЕМУ желанию ПЛАТНО."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-error" }, [
                              _vm._v(
                                "Телефоны, раковины, телевизоры не пишите!"
                              ),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4128205204
                ),
              }),
              _vm._v(" "),
              _c("calculation", { attrs: { "ancet-id": this.ancet.id } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ancet-form__actions ancet-actions" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--primary ancet-actions__btn-submit",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.saveAncet((_vm.sended = true))
                  },
                },
              },
              [_vm._v("Отправить анкету")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn btn--surface-container ancet-actions__btn-copy-link",
                attrs: {
                  title: "Скопировать ссылку на анкету",
                  type: "button",
                },
                on: {
                  click: function ($event) {
                    return _vm.getPasswordLink()
                  },
                },
              },
              [
                !_vm.copied ? _c("i", { staticClass: "fa fa-copy" }) : _vm._e(),
                _vm.copied ? _c("i", { staticClass: "fa fa-check" }) : _vm._e(),
                _vm._v(" Ссылка на анкету\n        "),
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.ancet && _vm.ancetSended
      ? _c("div", { staticClass: "ancet__sended-message sended-ancet" }, [
          _c("div", { staticClass: "sended-ancet__message" }, [
            _vm._v(
              "Анкета заполнена и отправлена. Если необходимо, вы можете отредактировать анкету и отправить повторно. Сохраните ссылку на анкету, чтобы вы могли отредактировать ее позднее."
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sended-ancet__actions" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--primary sended-ancet__edit-ancet",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.editAncet()
                  },
                },
              },
              [_vm._v("Редактировать анкету")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sended-ancet__link-label" }, [
            _vm._v("Ссылка на анкету:"),
          ]),
          _vm._v(" "),
          _vm.ancet.link_password
            ? _c("div", { staticClass: "sended-ancet__password-link" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.ancet.get_absolute_url) + "\n      "
                ),
                !_vm.copied
                  ? _c(
                      "button",
                      {
                        staticClass: "sended-ancet__copy-link",
                        attrs: {
                          title: "Скопировать ссылку на анкету",
                          type: "button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getPasswordLink()
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-copy" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.copied
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "sended-ancet__copy-link sended-ancet__copy-link--success",
                        attrs: {
                          title: "Скопировать ссылку на анкету",
                          type: "button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getPasswordLink()
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-check" })]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ancet-actions__legal" }, [
      _vm._v("Отправляя анкету, вы принимаете "),
      _c("a", { attrs: { href: "/legal/" } }, [
        _vm._v("условия обработки персональных данных"),
      ]),
      _vm._v("."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }